// Google Ads conversion helper for the v2 funnel. Pairs with GtagLoader.js
// (which injects gtag.js). fireConversion() is called once the lead completes
// (Step 6) to record the conversion, deduped per leadId so reloads/back-nav
// don't double-count.

export const GADS_CONVERSION_ID = "AW-18125368614";
export const GADS_CONVERSION_LABEL = "StkACP-q2rQcEKba7MJD";

export function fireConversion(leadId) {
  // Never send real conversions from dev/test builds — just log so we can
  // verify the call site fired.
  if (process.env.NODE_ENV !== "production") {
    console.log("[gtag] dev mode: would fire conversion for leadId=" + leadId);
    return;
  }

  if (!leadId) return;

  const key = "gads_fired_" + leadId;

  try {
    // Dedup: only fire once per lead, even across reloads/remounts.
    if (localStorage.getItem(key)) {
      console.log("[gtag] already fired for leadId=" + leadId);
      return;
    }

    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: GADS_CONVERSION_ID + "/" + GADS_CONVERSION_LABEL
      });
      // Mark fired only after an actual send, so a missing gtag can retry.
      localStorage.setItem(key, "1");
    }
  } catch (err) {
    // Tracking must never break the funnel.
    console.log("[gtag] conversion failed for leadId=" + leadId, err);
  }
}
